import { Input } from '@aigc/antd';
import { AiModal } from '@aigc/components';
import { useSubmitFn } from '@aigc/hooks';
import { useOverlayRef } from '@aigc/overlay-hook';
import { yupResolver } from '@hookform/resolvers/yup';
import { useMutation } from '@tanstack/react-query';
import { App, Form } from 'antd';
import { useForm } from 'react-hook-form';
import { object, ref, string } from 'yup';
import { FormControl } from '../../../components/form-control';
import { changePasswordMutation } from '../api';

export const ChangePasswordModal = () => {
  const { message } = App.useApp();
  const overlayRef = useOverlayRef();
  const { control, handleSubmit } = useForm({
    resolver: yupResolver(
      object({
        old_password: string().nullable().required(),
        new_password: string()
          .nullable()
          .notOneOf([ref('old_password')], '新密码不能与旧密码相同')
          .min(8, ({ min }) => `密码长度不能少于 ${min} 位`)
          .max(20, ({ max }) => `密码长度不能超过 ${max} 位`)
          .matches(
            /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d).+$/,
            '密码必须包含大写字母、小写字母和数字',
          )
          .required(),
        confirm_password: string()
          .nullable()
          .required()
          .oneOf([ref('new_password')], '两次输入的密码不一致'),
      }),
    ),
  });

  const changePassword = useMutation(changePasswordMutation);

  const onConfirm = useSubmitFn(
    handleSubmit(async (values) => {
      await changePassword.mutateAsync({
        new_password: values.new_password,
        old_password: values.old_password,
      });

      message.success('密码修改完成');

      overlayRef.close();
    }),
  );

  return (
    <AiModal
      title="修改密码"
      width={400}
      confirmLoading={changePassword.isPending}
      onCancel={() => overlayRef.close()}
      onOk={onConfirm}
    >
      <Form layout="vertical">
        <FormControl
          control={control}
          name="old_password"
          label="旧密码"
          render={({ field }) => (
            <Input.Password
              {...field}
              type="password"
              autoComplete="off"
            ></Input.Password>
          )}
        ></FormControl>
        <FormControl
          control={control}
          name="new_password"
          label="新密码"
          render={({ field }) => (
            <Input.Password
              {...field}
              type="password"
              autoComplete="off"
            ></Input.Password>
          )}
        ></FormControl>
        <FormControl
          control={control}
          name="confirm_password"
          label="确认密码"
          render={({ field }) => (
            <Input.Password
              {...field}
              type="password"
              autoComplete="off"
            ></Input.Password>
          )}
        ></FormControl>
      </Form>
    </AiModal>
  );
};
